// auth.js
import { getAuth } from 'firebase/auth';

const auth = getAuth();

export const getToken = async () => {
  const user = auth.currentUser;
  if (user) {
    return await user.getIdToken();
  }
  return null;
};
